import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.map.js";
import { isArray } from 'lodash';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.prototype.$dispatch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(actions) {
      var returnData,
        i,
        data,
        _args = arguments,
        _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            returnData = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            if (!isArray(actions)) {
              actions = [actions];
            }
            if (typeof actions[0] === 'string') {
              actions = actions.map(function (action) {
                return {
                  action: action,
                  params: {},
                  message: 'Loading...'
                };
              });
            }
            _context.prev = 1;
            i = 0;
          case 2:
            if (!(i < actions.length)) {
              _context.next = 5;
              break;
            }
            this.$q.loading.show({
              delay: 400,
              message: actions[i].message
            });
            _context.next = 3;
            return this.$store.dispatch(actions[i].action, actions[i].params);
          case 3:
            data = _context.sent;
            if (actions[i].successMessage) {
              this.$q.notify({
                icon: 'done',
                color: 'green-5',
                textColor: 'white',
                message: actions[i].successMessage
              });
            }
          case 4:
            i++;
            _context.next = 2;
            break;
          case 5:
            this.loading = false;
            this.$q.loading.hide();
            return _context.abrupt("return", returnData ? data : true);
          case 6:
            _context.prev = 6;
            _t = _context["catch"](1);
            this.$q.notify({
              color: 'red-5',
              message: _t.response.status === 500 ? "It's not you, it's us! There was a problem with the request." : _t.response.data,
              timeout: 6000,
              textColor: 'white',
              icon: 'warning'
            });
            this.$q.loading.hide();
            return _context.abrupt("return", false);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[1, 6]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
});